import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  Card, Checkbox,
  DatePicker, Dropzone, Select,
  TextInput,
  Title,
  Title1,
  Title2,
  Label, Button, TextIcon,
  Icon,
} from 'advenio-components'
import styled from 'styled-components'
import { Form } from 'formsy-react'
import ProfileHeader from '../../Components/ProfileHeader'
import moment from 'moment' //eslint-disable-line
import ServiceOccasionalActions from '../../Data/Redux/ServiceOccasionalRedux'
import { push } from "react-router-redux";
import { isNil } from "ramda";

const Container = styled.div`
  padding: 54px;
`
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
`
const BodyContainer = styled(Card)`
  padding: 8px;
`
const FormContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
`

const InputContainer = styled.div`
  width: calc(100% - 32px);
  margin: 16px;
  @media (min-width: 1024px) {
    width: 250px;
  }
  @media (min-width: 1440px) {
    width: 270px;
  }
`

const DropzoneContainer = styled.div`
  height: 200px;
  width: 100%;
  margin: 16px 0;
`
const ButtonBack = styled(Button)`
  height: 42px;
  margin-right: 16px;
  font-size: 15px;
  padding: 10px 16px 10px 16px;
  display: ${props => props.noSave ? 'none' : 'block'};
  @media (max-width:1300px) {
    height: 32px;
    margin-right: 8px;
    font-size: 12px;
    width: 60px;
    padding: 4px 8px 4px 8px;
  }
`
class NewServiceOccasional extends Component {
  state = {
    showSelect: true,
    file: null,
    amount_total: 0,
    amount_tuition_fee: 0,
    amount_extra: 0,
    program: 'Campamento',
    services: {
      Campamento: [
        { id: 1, value: 'Daycare', label: 'Daycare' },
        { id: 2, value: 'Medio Dia', label: 'Medio Dia' },
        { id: 3, value: 'Alimentos', label: 'Alimentos' },
        { id: 4, value: 'Otro', label: 'Otro' },
      ],
      Ocasional: [
        { id: 1, value: 'Daycare', label: 'Daycare' },
        { id: 2, value: 'Medio Dia', label: 'Medio Dia' },
        { id: 3, value: 'Talleres', label: 'Talleres' },
        { id: 4, value: 'Alimentos', label: 'Alimentos' },
        { id: 5, value: 'Consejo Tecnico', label: 'Consejo Tecnico' },
        { id: 6, value: 'Otro', label: 'Otro' },
      ],
    },
    optionsServices: [],
    charges: [],
  }

  componentWillReceiveProps(nextProps, nextContext) {
    console.log(nextProps, this.props)
    if (isNil(nextProps.serviceError) && !nextProps.loading) {
      this.props.goTo('/occasional')
    }
  }

  componentWillMount() {
    this.setState({ optionsServices: this.state.services['Campamento'] })
  }

  addCharge = () => {
    this.setState({ charges: [...this.state.charges, { amount_tuition_fee: 0, service: this.state.optionsServices[0].value }] })
  }

  removeCharge = (service) => {
    const charges = this.state.charges.filter((charge) => charge.service !== service)
    this.setState({ charges })
  }

  handleChangeService = (e, index) => {
    const charges = this.state.charges
    charges[index].service = e.target.value
    this.setState({ charges })
  }

  handleChangeAmount = (e, index) => {
    const charges = this.state.charges
    charges[index].amount_tuition_fee = e.target.value
    this.setState({ charges })
  }

  handleChangeProgram = ({ target: { value } }) => {
    this.setState({ program: value, optionsServices: this.state.services[value], charges: [] })
  }

  onSubmit = (data) => {
    const date = moment().
      hour(moment().hour()).
      minute(moment().minute()).
      second(moment().second()).
      format('YYYY-MM-DD HH:mm:SS')
    const newForm = new FormData()
    newForm.append('first_name', data.first_name)
    newForm.append('last_name_paternal', data.last_name_paternal)
    newForm.append('last_name_maternal', data.last_name_maternal)
    newForm.append('start_date', data.start_date)
    newForm.append('end_date', data.end_date)
    newForm.append('date_assistant', date)
    newForm.append('program', data.program)
    newForm.append('service', data.service)
    newForm.append('amount_total', this.state.amount_total)
    newForm.append('amount_extra', 0)
    newForm.append('need_invoice', data.need_invoice)
    newForm.append('charges', JSON.stringify(this.state.charges))
    if (this.state.file) {
      newForm.append('receipt_path', this.state.file)
    }
    this.props.postService(this.props.user.center_id, newForm)
  }

  handleChange = (data, charges) => {
    let showSelect = false
    const { program } = data
    if (program === 'Campamento') {
      showSelect = true
    }
    this.setState({ showSelect })
    if (this.state.charges.length > 0) {
      let amountTotal = 0
      this.state.charges.forEach((charge) => {
        charge.amount_tuition_fee = charge.amount_tuition_fee || 0
        amountTotal += Number(charge.amount_tuition_fee)
      })
      this.setState({ amount_total: amountTotal })
    }
  }

  handleFileUpload = file => this.setState({ file })

  render() {
    const { showSelect, amount_total, charges, optionsServices, program } = this.state
    const { loading } = this.props
    return (<Container>
      <HeaderContainer>
        <Title>Servicio Ocasional</Title>
      </HeaderContainer>
      <BodyContainer>
        <Form onSubmit={this.onSubmit} onChange={(data) => this.handleChange(data, charges)}>
          <ProfileHeader
            header="Alta Servicio"
            submit
            loading={loading}
            buttons={[<ButtonBack key={1} loading={loading} secondary small onClick={() => this.props.goTo('/occasional')} type="button">
              Regresar
            </ButtonBack>,]}
          />
          <FormContainer>
            <InputContainer>
              <TextInput
                name="first_name"
                label="Nombre"
                value={''}
                required
              />
            </InputContainer>
            <InputContainer>
              <TextInput
                name="last_name_paternal"
                label="Apellido Paterno"
                value={''}
                required
              />
            </InputContainer>
            <InputContainer>
              <TextInput
                name="last_name_maternal"
                label="Apellid Materno"
                value={''}
                required
              />
            </InputContainer>
            <InputContainer>
              <DatePicker
                name="start_date"
                label="Fecha de inicio"
                required
              />
            </InputContainer>
            <InputContainer>
              <DatePicker
                name="end_date"
                label="Fecha de fin"
                required
              />
            </InputContainer>
            <InputContainer>
              <Select
                name="program"
                label="Tipo de Programa"
                require
                onChangeCallback={(e) => this.handleChangeProgram(e)}
                options={[
                  {
                    id: 1,
                    value: 'Campamento',
                    label: 'Campamento',
                  },
                  {
                    id: 2,
                    value: 'Ocasional',
                    label: 'Ocasional',
                  },
                ]}
              />
            </InputContainer>
            <InputContainer>
              <Button
                small
                success
                disabled={charges.length === this.state.services[program].length}
                onClick={() => this.addCharge()}
              >
                <TextIcon iconType='plus' label='Agregar' />
              </Button>
            </InputContainer>
            {charges.map((charge, index) => (
              <div key={index} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                {index > 0 && (
                  <InputContainer>
                    <Button
                      small
                      danger
                      onClick={() => this.removeCharge(charge.service)}
                    >
                      <TextIcon iconType='close' label='Eliminar' />
                    </Button>
                  </InputContainer>
                )}
                <InputContainer>
                  <Select
                    name="service"
                    label="Servicio"
                    require
                    onChangeCallback={(e) => this.handleChangeService(e, index)}
                    value={charge.service}
                    options={optionsServices}
                  />
                </InputContainer>
                <InputContainer>
                  <TextInput
                    name="amount_tuition_fee"
                    label="Colegiatura"
                    type="number"
                    value={charge.amount_tuition_fee}
                    onChangeCallback={(e) => this.handleChangeAmount(e, index)}
                    required
                  />
                </InputContainer>
              </div>))}
            <InputContainer>
              <TextInput
                name="amount_total"
                label="Monto a comprobrar"
                type="number"
                value={amount_total}
                required
                disabled
              />
            </InputContainer>
            <InputContainer>
              <Checkbox
                name="need_invoice"
                label="Requiere Factura"
                invertedColors
                large
                hideEmptyHelpBlock
                value={false}
              />
            </InputContainer>
            <InputContainer style={{ width: 350 }}>
              <DropzoneContainer>
                <div
                  style={{ fontSize: 14, color: '#212B36', marginBottom: 5 }}
                >
                  Subir Comprobante
                </div>
                <Dropzone
                  onDrop={this.handleFileUpload}
                  label="Da click o arrastra un documento aquí"
                  onDragLabel="Soltar Documento"
                  ref={(dropzone) => { this.dropzone = dropzone }}
                />
              </DropzoneContainer>
            </InputContainer>
          </FormContainer>
        </Form>
      </BodyContainer>
    </Container>)
  }
}

NewServiceOccasional.defaultProps = {
  loading: false,
  serviceError: null,
}

const mapStateToProps = state => ({
  user: state.auth.user,
  loading: state.serviceOccasional.sending.fetching,
  serviceError: state.serviceOccasional.sending.error,
})

const mapDispatchToProps = dispatch => ({
  postService: (centerId, data) =>
    dispatch(ServiceOccasionalActions.postServiceOccasionalRequest(centerId, data)),
  goTo: path => dispatch(push(path)),
})
export default connect(mapStateToProps, mapDispatchToProps)(NewServiceOccasional)



// WEBPACK FOOTER //
// ./src/Containers/ServiceOccasional/NewServiceOccasional.jsx